import React from 'react';

import Dropzone from 'react-dropzone';

import styles from './styles.module.scss';

const renderDropzoneInput = (dropzone, accept) => field => (
  <div>
    {/* Autoscrolling */} <input type="hidden" name={field.input.name} />
    <Dropzone
      ref={node => {
        dropzone.ref = node;
      }}
      name={field.name}
      accept={accept}
      className={field.className}
      multiple={field.multiple}
      style={field.style}
      maxSize={field.maxSize}
      data-test="dropzone"
      onDrop={filesToUpload => field.input.onChange(filesToUpload)}
      onDropRejected={rejectedFiles => field.onDropRejected(rejectedFiles)}
    />
    {!field.meta.error && field.labelDropzone}
    {field.meta.touched &&
      field.meta.error && (
        <div className={styles.error}>{field.meta.error}</div>
      )}
  </div>
);

export default renderDropzoneInput;
